import { Box, Container, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  CardVariant,
  WsCard,
  WsIconJDParse,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

const InvoiceCreateOptions = () => {
  const navigate = useNavigate();
  const navigateToAddInvoice = () => navigate('/invoice/add');
  const navigateToConvertCandidate = () => navigate('/invoice/candidatelist');

  return (
    <Container
      style={{
        marginTop: '7%',
        marginBottom: '3%',
        backgroundColor: 'white',
        padding: '2%',
      }}
    >
      <Box textAlign="center">
        <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.PRIMARY900}>
          Add Invoice
        </WsTypography>
        <Grid container marginTop="10%">
          <Grid xs={6}>
            <WsCard
              title="Add Manually"
              buttonText="Continue here"
              description="Click here to create Invoice manually"
              isButton={true}
              cardType={CardVariant.WITH_LIGHT_BG}
              middleComponent={<WsIconJDParse width={96} height={110} />}
              onClick={() => navigateToAddInvoice()}
            />
          </Grid>
          <Grid xs={6}>
            <WsCard
              title="Invoice Candidate"
              buttonText="Select Candidate"
              description="Click here to select candidate and raise invoice"
              isButton={true}
              middleComponent={<WsIconJDParse width={96} height={110} />}
              onClick={() => navigateToConvertCandidate()}
            />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default InvoiceCreateOptions;
